module.exports = __webpack_public_path__ + "assets/img/SIL_3.c16fa535.png";